import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  root: {
    cursor: "pointer",
    [theme.breakpoints.up("md")]: {
      margin: "30px 0px 0px 30px",
    },
    [theme.breakpoints.down("lg")]: {
      margin: "30px 0px 0px 30px",
    },
  },
  logo: {
    overflow: "visible",
    width: "148px !important",
    height: "33px !important",
  },
}));

export default useStyles;
